import { Box, Typography, withStyles } from "@material-ui/core";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import React from 'react';

const color1 = "#0D3C82", color2 = "#707070";

const style = () => ({
    root: {
        width: "100%",
        paddingLeft: 5,
        paddingRight: 5,
        // transform: translateZ(0),
        translateZ: 0,
        // backgroundColor: "#00000025"
    },
    textPrimary: {
        fontSize: 12,
        color: color1,
    },
    textSecondary: {
        fontSize: 12,
        color: color2,
    },
    dot: {
        color: color1,
        height: 15,
        width: 15,
    },
});

const PasswordPolicy = props => {
    const { classes } = props;
    return (
        <Box className={classes.root}>
            <Box display="flex" flexDirection="row">
                <FiberManualRecordIcon className={classes.dot} />
                <Typography className={classes.textPrimary}>
                    At least 8 characters in length
                </Typography>
            </Box>
            <Box display="flex" flexDirection="row">
                <FiberManualRecordIcon className={classes.dot} />
                <Box>
                    <Typography className={classes.textPrimary}>
                        Must contain at least one:
                    </Typography>
                    <Typography className={classes.textSecondary}>
                        Lower-case (a-z), Upper-case (A-Z), Number (0-9), Special Character (@, $, etc.)
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default withStyles(style)(PasswordPolicy);
